module.exports = __webpack_public_path__ + "img/mda.993d542e.svg";